import { Caption, LabelMini, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogDetailCurators } from '@/redux/modules/catalog/detail/catalogDetail.selectors';
import { getCuratorBaseUrl } from '@/redux/modules/config';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getCuratorImageUrl } from '@/utils/urls';

const HEADSHOT_SIZE_PX = 48;

type Props = {
    catalogId: number;
    className?: string;
};

export const AuctionCuratedBy = ({ catalogId, className }: Props) => {
    const formatMessage = useAppFormatMessage();
    const curators = useAppSelector((state) => getCatalogDetailCurators(state, catalogId)) || [];
    const curatorImgUrl = useAppSelector(getCuratorBaseUrl);

    if (!curators.length) {
        return null;
    }

    return (
        <div
            className={cn('flex flex-col gap-xs', className)}
            data-testid="auction-curated-by"
        >
            <LabelMini className="uppercase">
                {formatMessage(['catalogPage', 'catalogDetailsZone', 'auctionCuratedBy'])}
            </LabelMini>
            {curators.map(({ expertise, id, imageFileName, name }) => (
                <div
                    className="flex items-center gap-xs"
                    key={id}
                >
                    <div
                        className="shrink-0 overflow-hidden rounded-full"
                        style={{ height: HEADSHOT_SIZE_PX, width: HEADSHOT_SIZE_PX }}
                    >
                        <img
                            alt={name}
                            className="size-full object-cover"
                            height={HEADSHOT_SIZE_PX}
                            src={getCuratorImageUrl(curatorImgUrl, id, imageFileName, HEADSHOT_SIZE_PX)}
                            width={HEADSHOT_SIZE_PX}
                        />
                    </div>
                    <div className="flex flex-col gap-2xs">
                        <LabelStrong>{name}</LabelStrong>
                        <Caption color="secondary">{expertise}</Caption>
                    </div>
                </div>
            ))}
        </div>
    );
};
